import React, { useState } from "react";
import { TASK_LABEL } from "./taskCopy";

export const AVAILABILITY_EXPLANATION =
  "Agents may claim this Task and submit work for review. They cannot approve, merge, or deploy it.";

export function availabilityExplanationFor(agentName) {
  if (!agentName) return AVAILABILITY_EXPLANATION;
  return `${agentName} may claim this Task and submit work for review. It cannot approve, merge, or deploy it.`;
}

function AgentAvailabilityControl({
  item,
  mutateAllowed,
  busy,
  onAuthorize,
  onRevoke,
}) {
  const [confirming, setConfirming] = useState(false);
  const execution = item.agentExecution || {};
  const available = Boolean(execution.availableToAgents);
  const agentName = execution.agentDisplayName || "";

  if (!item.workBriefId) return null;

  if (!mutateAllowed) {
    return (
      <p className="roadmap-item-link-label" data-testid={`agent-availability-readonly-${item.id}`}>
        {available
          ? `${agentName ? `Available to ${agentName}` : "Available to agents"}. You can view this, but you cannot change it.`
          : `Not available to ${agentName || "agents"}.`}
      </p>
    );
  }

  if (available) {
    return (
      <button
        type="button"
        className="secondary-button"
        disabled={busy}
        onClick={() => onRevoke(item)}
        data-testid={`agent-pause-${item.id}`}
      >
        {agentName ? `Pause ${agentName} access` : "Pause agent access"}
      </button>
    );
  }

  if (!confirming) {
    return (
      <button
        type="button"
        className="secondary-button"
        disabled={busy}
        onClick={() => setConfirming(true)}
        data-testid={`agent-make-available-${item.id}`}
      >
        {agentName ? `Make available to ${agentName}` : "Make available to agents"}
      </button>
    );
  }

  return (
    <div className="agent-availability-confirm" data-testid={`agent-confirm-${item.id}`}>
      <p>{availabilityExplanationFor(agentName)}</p>
      <button
        type="button"
        className="primary-button"
        disabled={busy}
        onClick={() => onAuthorize(item)}
        data-testid={`agent-confirm-available-${item.id}`}
      >
        Confirm for this {TASK_LABEL}
      </button>
      <button type="button" className="secondary-button" onClick={() => setConfirming(false)}>
        Cancel
      </button>
    </div>
  );
}

export default AgentAvailabilityControl;
